export default "__VITE_ASSET__54dab7ea__"